import { take } from '@immutabl3/utils';
import { Badge } from '../components/home/badge';
import { Spinner } from '../components/spinner';
import { useLeaderboardGlobal } from '../query';
import styles from './showcase.module.css';

export const Showcase = () => {
  const {
    isError,
    isLoading,
    data: users,
  } = useLeaderboardGlobal();

  if (isError) return null;
  if (!isLoading && !users.length) return null;

  return (
    <ol
      className={ styles.showcase }
      data-state={ isError ? "error" : isLoading ? "loading" : "ready" }
    >
      { isLoading && <Spinner /> }
      { take(users, 3).map((user, idx) => {
        return (
          <li key={ idx }>
            <Badge name={ user.name } />
            <p>
              { user.name }
              <span>{ user.score }</span>
            </p>
            <div
              className={ styles.pedestal }
              data-rank={ idx + 1 }
            />
          </li>
        );
      }) }
    </ol>
  );
};